import { handleResponse, handleError, getProductApiUrl, queryValue } from "./apiUtils";
import getRequestOptions from './authorizationUtils';
import axios from 'axios';

// Served by the tenant's sugar instance (module Products), not by the ProductGroup azure
// function app any more. The request and response shapes are unchanged.

export function ReadProductGroups(filter, sort, page, cancelToken) {
  const options = getRequestOptions(cancelToken);
  return axios.get(getProductApiUrl() + `JSONProductGroupGetAll&filter=${queryValue(filter)}&sort=${queryValue(sort)}&page=${queryValue(page)}`, options)
      .then(handleResponse)
      .catch(handleError);
}

export function ReadProductGroup(id) {
    const options = getRequestOptions();
    return axios.get(getProductApiUrl() + `JSONProductGroupGet&id=${queryValue(id)}`, options)
        .then(handleResponse)
        .catch(handleError);
  }

export function updateProductGroup(productGroup) {
    const options = getRequestOptions();
    return axios.post(getProductApiUrl() + `JSONProductGroupPost`, productGroup, options)
        .then(handleResponse)
        .catch(handleError);
}
